import Image from 'next/image';
import MainLogo from '@/images/branding/logo-empire-nine-digital.svg';
import "@/styles/components/ui/logo.css";

export default function Logo({title}) {
  return (
    <a href="/" className="logo-main">
      <Image
        src={MainLogo.src}
        alt={title}
        width={360}
        height={36}
        unoptimized={true}
        loading='eager'
      />
    </a>
  );
}
